import React from 'react';

const NurturingDevService = ({ data }) => {
  return (
    <section className="p-80px-tb nurturing-dev-service" style={{backgroundColor: 'white'}}>
      <div className="container">
        <div className="row">
          <div className="col-md-12 m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.title}</h2>
            <p className="lead text-primary font-weight-bold m-20px-b">{data.lead}</p>
            <p className="text-muted">{data.content}</p>
          </div>
        </div>

        {/* 3つの永続的な価値 */}
        <div className="row m-50px-t">
          <div className="col-md-12 m-30px-b">
            <h3 className="h3 font-weight-bold">{data.benefitsTitle}</h3>
          </div>
          {data.benefits.map((benefit, index) => (
            <div key={index} className="col-lg-4 col-md-6 m-30px-b">
              <div className="card h-100 shadow-sm">
                <div className="card-body text-center p-40px">
                  <div className="benefit-icon m-25px-b">
                    <i className={`${benefit.icon} icofont-4x text-primary`}></i>
                  </div>
                  <h5 className="card-title font-weight-bold m-20px-b">{benefit.title}</h5>
                  <p className="card-text text-muted">{benefit.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 2つのアプローチ */}
        <div className="row m-50px-t">
          <div className="col-md-12 m-30px-b text-center">
            <h3 className="h3 font-weight-bold">{data.methodsTitle}</h3>
          </div>
          {data.methods.map((method, index) => (
            <div key={index} className="col-lg-6 m-30px-b">
              <div className="method-card bg-white rounded p-40px h-100 shadow-sm">
                <h4 className="font-weight-bold m-25px-b">{method.title}</h4>
                <p className="text-muted m-25px-b">{method.content}</p>
                {/* メソッドのビジュアル */}
                <div className="method-visual">
                  <img
                    src={index === 0
                      ? process.env.PUBLIC_URL + "/assets/img/ss1.png"
                      : process.env.PUBLIC_URL + "/assets/img/ss2.png"}
                    alt={index === 0 ? 'ノーコードツール画面' : 'コードレビュー風景'}
                    className="img-fluid rounded"
                    style={{width: '100%', height: 'auto'}}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NurturingDevService;